import React, { Component } from "react";
import API from "../../apiService.js";
import moment from "moment";
import ALERT, { showLoading } from "../component/Alert";
import PrintButton from "../medical/PrintButton";
import FormPeriksaPrint from "./FormPeriksaPrint";
import SuratPeriksaList from "./SuratPeriksaList";

export default class FormButaWarna extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refExplanation: [],
      data: {
        visit_id: this.props.detilPx.id,
        number: "",
        result: "Buta Warna",
        mc_see: true,
        mc_hear: true,
        explanation_id: 1,
        other_explanation: "",
        explanation: "",
      },
      profiles: "",
      nomor_surat: "",
      letters: [],
      created: false
    };
  }
  componentDidMount() {
    this.getExplanation();
    this.getProfile();
    this.getMedicalLetterNo();
    this.getLetters();
  }
  getMedicalLetterNo = async () => {
    let date = moment().format("YYYY-MM-DD");
    const res = await API.get(
      "registration/color_blind/select/" + date
    );
    if (res.code === 200) {
      this.setState((prevState) => ({
        data: {
          // object that we want to update
          ...prevState.data, // keep all other key-value pairs
          number: res.data, // update the value of specific key
        },
      }));
    }
  };
  getLetters = async () => {
    const res = await API.get(
      "registration/color_blind/read/" + this.props.detilPx.id
    );
    if (res.code === 200) {
      this.setState({
        letters: res.data,
      });
    }
  };

  getExplanation = async () => {
    const res = await API.get("management/color_blind/read");
    if (res.code === 200) {
      this.setState({
        refExplanation: res.data,
      });
    }
  };

  getProfile = async () => {
    let userdata = JSON.parse(localStorage.getItem("userData"));
    let puskesmas_id = userdata.puskesmas_id;
    const res = await API.get("/management/profiles/read?code=" + puskesmas_id);
    if (res.code === 200) {
      this.setState({
        profiles: res.data,
      });
      this.setState({
        nomor_surat:
          "/" +
          res.data.nama_singkat +
          "/" +
          this.convertToRom(moment().format("M")) +
          "/" +
          moment().format("YYYY"),
      });
    }
  };
  handleChangeText = (event) => {
    let value = event.target.value;
    let object = event.target.name;
    let data;
    this.setState((prevState) => ({
      data: {
        // object that we want to update
        ...prevState.data, // keep all other key-value pairs
        [object]: value, // update the value of specific key
      },
    }));
  };
  handleChangeTextExplanation = (event) => {
    let value = event.target.value;
    let object = event.target.name;
    let id = event.target.id;
    let data;
    this.setState((prevState) => ({
      data: {
        // object that we want to update
        ...prevState.data, // keep all other key-value pairs
        [object]: value, // update the value of specific key
        explanation: id,
      },
    }));
  };
  onReload = () => {
    this.props.history.push("/pelayanan");
  };

  PostData = async () => {
    showLoading('Membuat surat')
    var param = {
      visit_id: this.state.data.visit_id,
      color_blind: this.state.data.result,
      number: this.state.data.number + this.state.nomor_surat,
    };

    let res = await API.post(`registration/color_blind/create`, param);

    if (res.code === 200) {
      if (res.code === 200) {
        ALERT("success", "Berhasil Menyimpan Data ");
        this.setState({created: true})
        this.getLetters();
      } else {
        ALERT("error", "gagal menyimpan data");
      }
    }
  };

  convertToRom(num) {
    var remainingValue = num;
    var newRomanNumeral = "";

    var romanNumerals = [
      {
        numeral: "M",
        value: 1000,
      },
      {
        numeral: "CM",
        value: 900,
      },
      {
        numeral: "D",
        value: 500,
      },
      {
        numeral: "CD",
        value: 400,
      },
      {
        numeral: "C",
        value: 100,
      },
      {
        numeral: "XC",
        value: 90,
      },
      {
        numeral: "L",
        value: 50,
      },
      {
        numeral: "XL",
        value: 40,
      },
      {
        numeral: "X",
        value: 10,
      },
      {
        numeral: "IX",
        value: 9,
      },
      {
        numeral: "V",
        value: 5,
      },
      {
        numeral: "IV",
        value: 4,
      },
      {
        numeral: "I",
        value: 1,
      },
    ];

    for (var i = 0; i < 13; i++) {
      var j = Math.floor(remainingValue / romanNumerals[i].value); // j represents the number of times each character is needed
      while (remainingValue >= romanNumerals[i].value) {
        newRomanNumeral += romanNumerals[i].numeral.repeat(j); // Add 'x' Numerals to the string
        remainingValue -= romanNumerals[i].value * j; // decrement the remaining value
      }
    }

    return newRomanNumeral;
  }

  render() {
    console.log(this.state);

    let explanation = this.state.refExplanation.map((ex, ky) => {
      return (
        <div key={ky} className='custom-control custom-radio'>
          <input
            name='explanation_id'
            className='custom-control-input'
            id={ex.name}
            value={ex.id}
            type='radio'
            onChange={this.handleChangeTextExplanation}
          />
          <label className='custom-control-label' htmlFor={ex.name}>
            {ex.name}
          </label>
        </div>
      );
    });
    let nomor_surat = this.state.nomor_surat;
    // console.log(this.props);
    return (
      <div>
        <div className='card'>
          <div className='card-header'>
            <div className='row align-items-center'>
              <div className='col-8'>
                <h4 className='h3 mb-0'>Form Surat Keterangan Buta Warna</h4>
              </div>
              {this.state.letters.length > 0 ? (
                <div className='col-4 text-right'>
                  <PrintButton
                    url={`/registration/color_blind/print/${this.state.letters[0].id}`}
                    buttonText='Cetak'
                    color='neutral'
                  />
                </div>
              ) : (
                ""
              )}
            </div>
            <div className='collapse' id='collapsePreview'>
              <br></br>
              <div className='list-group-item' style={{ display: "block" }}>
                <FormPeriksaPrint
                  ref={(el) => (this.componentRef = el)}
                  patient={this.props.detilPx}
                  letter={this.state.letters[0]}
                />
              </div>
            </div>
          </div>
          <div className='card-body'>
            <div className='form-group row'>
              <label
                htmlFor='example-text-input'
                className='col-md-5 col-form-label col-form-label-sm'>
                Nomor
              </label>
              <div className='col-md-7'>
                <div className='row'>
                  <input
                    className='form-control col-md-3'
                    type='text'
                    placeholder='nomor'
                    name='number'
                    value={this.state.data.number}
                    onChange={this.handleChangeText}
                  />
                  <input
                    className='form-control col-md-9'
                    type='text'
                    name='nomor_singkatan'
                    value={nomor_surat}
                    readOnly
                  />
                </div>
              </div>
            </div>
            <div className='form-group row'>
              <label
                  htmlFor='example-text-input'
                  className='col-md-5 col-form-label col-form-label-sm'>
                Hasil
              </label>
              <div className='col-md-7'>
                <div className='row'>
                  <div className='custom-control custom-radio col-md-4 '>
                    <input
                        name='result'
                        className='custom-control-input'
                        id='buta_warna'
                        type='radio'
                        checked={this.state.data.result === "Buta Warna"}
                        value='Buta Warna'
                        onChange={this.handleChangeText}
                    />
                    <label
                        className='custom-control-label'
                        htmlFor='buta_warna'>
                      Buta Warna
                    </label>
                  </div>
                  <div className='custom-control custom-radio col-md-4 '>
                    <input
                        name='result'
                        className='custom-control-input'
                        id='tidak_buta_warna'
                        value='Tidak Buta Warna'
                        type='radio'
                        checked={this.state.data.result === "Tidak Buta Warna"}
                        onChange={this.handleChangeText}
                    />
                    <label
                        className='custom-control-label'
                        htmlFor='tidak_buta_warna'>
                      Tidak Buta Warna
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <button
              type='submit'
              className='btn btn-primary'
              onClick={this.PostData}>
              Simpan
            </button>
            <button className='btn btn-danger' onClick={this.onReload}>
              Tutup
            </button>
            <div className='col-12 mt-4'>
              <SuratPeriksaList
                patient={this.props.detilPx}
                letters={this.state.letters}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
